<jb-form-field-container type="primary" class="bg-white">
  <jb-input-label>{{ promoCodeData.label }}</jb-input-label>
  <input
    #promoCodeInput
    jbInput
    type="text"
    id="promo-code-text-field"
    [formControl]="formControl"
    name="promoCode"
    (change)="promoCodeChange.emit()"
  />
</jb-form-field-container>
